import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";

export const ReputationTimeline = ({ events, testid = "reputation-timeline" }) => (
    <div className="relative" data-testid={testid}>
        {events.map((e, i) => (
            <Reveal key={`${e.label}-${i}`} delay={i * 0.05}>
                <div className="relative flex items-start gap-5 pb-6 last:pb-0">
                    {i < events.length - 1 && (
                        <span className="absolute left-[7px] top-4 h-full w-px bg-gradient-to-b from-[#1677FF]/60 to-white/[0.06]" aria-hidden="true" />
                    )}
                    <span
                        className={`relative z-10 mt-1 h-[15px] w-[15px] shrink-0 rotate-45 border ${
                            e.delta?.startsWith("-") ? "border-[#FF5C7A] bg-[#FF5C7A]/15" : "border-[#31D8FF] bg-[#31D8FF]/10"
                        }`}
                    />
                    <div className="flex flex-1 flex-wrap items-center justify-between gap-x-6 gap-y-1 border-b border-white/[0.06] pb-4">
                        <div>
                            <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-ink">{e.label}</p>
                            {e.detail && <p className="mt-1 text-xs text-mute">{e.detail}</p>}
                        </div>
                        <div className="flex items-center gap-5">
                            {e.stamp && <span className="font-mono text-[10px] tracking-[0.16em] text-mute/60">{e.stamp}</span>}
                            {e.delta && (
                                <motion.span
                                    initial={{ opacity: 0, scale: 0.8 }}
                                    whileInView={{ opacity: 1, scale: 1 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.4 }}
                                    data-testid="reputation-delta"
                                    className={`font-mono text-sm font-semibold tabular-nums ${
                                        e.delta.startsWith("-") ? "text-[#FF5C7A]" : "text-[#31D8FF]"
                                    }`}
                                >
                                    {e.delta} reputation
                                </motion.span>
                            )}
                        </div>
                    </div>
                </div>
            </Reveal>
        ))}
    </div>
);

export default ReputationTimeline;
